/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { LocalDate } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface TimeOffDto
 */
export interface TimeOffDto {
  /**
   *
   * @type {string}
   * @memberof TimeOffDto
   */
  timeOffId: string;
  /**
   *
   * @type {LocalDate}
   * @memberof TimeOffDto
   */
  startDate: LocalDate;
  /**
   *
   * @type {LocalDate}
   * @memberof TimeOffDto
   */
  endDate: LocalDate;
  /**
   *
   * @type {string}
   * @memberof TimeOffDto
   */
  kind: string;
  /**
   *
   * @type {string}
   * @memberof TimeOffDto
   */
  note?: string | null;
}

/**
 * Check if a given object implements the TimeOffDto interface.
 */
export function instanceOfTimeOffDto(value: object): value is TimeOffDto {
  if (!("timeOffId" in value) || value["timeOffId"] === undefined) return false;
  if (!("startDate" in value) || value["startDate"] === undefined) return false;
  if (!("endDate" in value) || value["endDate"] === undefined) return false;
  if (!("kind" in value) || value["kind"] === undefined) return false;
  return true;
}

export function TimeOffDtoFromJSON(json: any): TimeOffDto {
  return TimeOffDtoFromJSONTyped(json, false);
}

export function TimeOffDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TimeOffDto {
  if (json == null) {
    return json;
  }
  return {
    timeOffId: json["timeOffId"],
    startDate: json["startDate"],
    endDate: json["endDate"],
    kind: json["kind"],
    note: json["note"] == null ? undefined : json["note"],
  };
}

export function TimeOffDtoToJSON(json: any): TimeOffDto {
  return TimeOffDtoToJSONTyped(json, false);
}

export function TimeOffDtoToJSONTyped(
  value?: TimeOffDto | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    timeOffId: value["timeOffId"],
    startDate: value["startDate"],
    endDate: value["endDate"],
    kind: value["kind"],
    note: value["note"],
  };
}
